import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import {Helmet} from 'react-helmet-async';
// sections
import {ModernLoginView} from 'src/sections/auth-demo/modern';
import {APP_NAME, RECAPTCHA_SITE_KEY} from 'src/config-global';
// ----------------------------------------------------------------------

export default function ModernLoginPage() {
  return (
    <>
      <Helmet>
        <title> Login | {APP_NAME}</title>
      </Helmet>

      <GoogleReCaptchaProvider
        reCaptchaKey={RECAPTCHA_SITE_KEY}
        useEnterprise={true}
        language={'en'}
      >
        <ModernLoginView />
      </GoogleReCaptchaProvider>
    </>
  );
}
